var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-table', {
    staticClass: "table-outline mb-0",
    attrs: {
      "hover": "hover",
      "responsive": "responsive",
      "outline": "outline",
      "head-variant": "default",
      "items": _vm.data,
      "fields": _vm.label,
      "small": _vm.small,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc
    },
    on: {
      "row-clicked": _vm.ping,
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "name",
      fn: function(item) {
        return [(item.value == "Total Intents" || item.value == "Total Unmatched" || item.value == "Total Matched" || item.value == "Total Conversations") ? _c('span', {
          staticClass: "bold"
        }, [_vm._v(_vm._s(item.value))]) : _c('span', [_vm._v(_vm._s(item.value))])]
      }
    }, {
      key: "number",
      fn: function(item) {
        return [_c('span', {
          staticClass: "bold"
        }, [_vm._v(_vm._s(item.value))])]
      }
    }, {
      key: "percent",
      fn: function(item) {
        return [_c('span', {
          staticClass: "bold"
        }, [_vm._v(_vm._s(item.value))])]
      }
    }, {
      key: "timestamp",
      fn: function(item) {
        return [_vm._v(_vm._s(_vm._f("moment")(item.value, "from", "now")))]
      }
    }])
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9bebbf3e","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConversationTopicTable.vue
// module id = 1550
// module chunks = 1